import { SET_BONUS, RESET_BONUS } from '../constants/bonuses';

export const setBonus = (bonus) => {
    return (dispatch) => {
        dispatch({
            type: SET_BONUS,
            payload: bonus,
        });
    };
};

export const resetBonus = () => {
    return (dispatch) => {
        dispatch({
            type: RESET_BONUS,
        });
    };
};
